import { computed, ref, watch } from '@vue/composition-api';
import { useToast } from 'vue-toastification/composition';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import useAccount from './useAccount';
import useUtils from "@/composables/useUtils";

const useAccountList = () => {
  const toast = useToast();
  const {formatCurrency} = useUtils();
  const { getAccountList } = useAccount();

  const perPageOptions = [10, 25, 50, 100];
  const tableColumns = [
    { key: 'name', sortable: true },
    {
      key: 'balance',
      formatter: (val) => formatCurrency(val),
    },
    { key: 'actions' }];

  const pageNumber = ref(1);
  const orderDesc = ref(true);
  const pageSize = ref(10);
  const refAccountsTable = ref(null);
  const searchQuery = ref(null);
  const orderBy = ref('id');
  const totalAccounts = ref(0);

  const dataMeta = computed(() => {
    const localItemsCount = refAccountsTable.value
      ? refAccountsTable.value.localItems.length
      : 0;

    return {
      from: pageSize.value * (pageNumber.value - 1) + (localItemsCount ? 1 : 0),
      to: pageSize.value * (pageNumber.value - 1) + localItemsCount,
      of: totalAccounts.value,
    };
  });

  watch([pageNumber, pageSize], () => {
    refAccountsTable.value.refresh();
  });

  const getAccountsList = (_, callback) => {
    const params = {
      orderBy: orderBy.value,
      orderDesc: orderDesc.value,
      pageSize: pageSize.value,
      pageNumber: pageNumber.value,
      searchQuery: searchQuery.value,
    };

    getAccountList(params)
      .then(({ accounts, total }) => {
        callback(accounts);
        totalAccounts.value = total;
      })
      .catch(() => {
        toast.error({
          component: ToastificationContent,
          props: {
            title: 'Error fetching account list',
            icon: 'XCircleIcon',
          },
        });
      });
  };

  return {
    // Const
    perPageOptions,
    tableColumns,

    // Reactive
    pageNumber,
    orderDesc,
    pageSize,
    refAccountsTable,
    searchQuery,
    orderBy,
    totalAccounts,

    // Computed
    dataMeta,

    // Method
    getAccountsList,
  };
};

export default useAccountList;
